"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["Svg", "position", "defaultPosition", "size", "style"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ArrowComponent = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(ArrowComponent, _React$PureComponent);

  function ArrowComponent() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = ArrowComponent.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Svg = _this$props.Svg,
        position = _this$props.position,
        defaultPosition = _this$props.defaultPosition,
        size = _this$props.size,
        _this$props$style = _this$props.style,
        style = _this$props$style === void 0 ? {} : _this$props$style,
        other = _objectWithoutPropertiesLoose(_this$props, _excluded);

    var rotate, offset;

    switch (defaultPosition) {
      case "up":
        offset = 180;
        break;

      case "left":
        offset = 270;
        break;

      case "right":
        offset = 90;
        break;

      default:
        offset = 0;
    }

    switch (position) {
      case "up":
        rotate = 180 + offset;
        break;

      case "left":
        rotate = 90 + offset;
        break;

      case "right":
        rotate = -90 + offset;
        break;

      default:
        rotate = 0 + offset;
    }

    return /*#__PURE__*/_react["default"].createElement(Svg, _extends({
      style: _extends({
        transform: "rotate(" + rotate + "deg)",
        transition: "transform 0.2s linear"
      }, style),
      size: size
    }, other));
  };

  return ArrowComponent;
}(_react["default"].PureComponent);

var _default = ArrowComponent;
exports["default"] = _default;
module.exports = exports.default;